// extracted by mini-css-extract-plugin
module.exports = {"panel":"BondFormPanel_panel__32-S_","disabled":"BondFormPanel_disabled__1GibL"};